import React, { useEffect, useState } from 'react'
import FormThirdInvolved from './FormThirdInvolved'
import FormInvolved from './FormInvolved'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import 'recupero-comunes/dist/index.css'
import { Formik, Form } from 'formik'
import Button from 'react-bootstrap/Button'
import Mensage from '../../../components/common/mensage'
import { connect } from 'react-redux'
import {
  getCBCasesCarBrand,
  getCBCasesCarType,
  getCBCasesCommune,
  getCBCasesCompany,
  getCBCasesSure,
  getCasesImplicatedDetail,
  postCasesImplicado,
  getCBCountry,
  cleanStateCase
} from '../../../store/actions'

import { validationSchema } from '../../../utils/validationSchema'
import { LoadingComponent } from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import moment from 'moment'
import { prettifyRut } from 'react-rut-formatter'
import FormProperty from './FormProperty'
import FormDrive from './FormDrive'

const FormImplicatedCases = ({
  data,
  onGetCBCarBrand,
  onGetCBCarType,
  onGetCBCompany,
  onGetCBComune,
  onGetGestionCasesImplicatedDetail,
  onGetCBSure,
  onPostImplicado,
  onGetCBCountry,
  onCleanState
}) => {
  const { state } = useLocation()
  const history = useNavigate()
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const [formValues, setFormValues] = useState({})
  const [loading, setLoading] = useState(false)
  const pais = 'Chile'

  const [comunaImplicado, setComunaImplicado] = useState('')
  const [comunaConductor, setComunaConductor] = useState('')
  const [comunaPropietario, setComunaPropietario] = useState('')

  useEffect(() => {
    onGetGestionCasesImplicatedDetail({
      idImplicado: state.row.IdImplicado,
      idCaso: state.idCaso
    })
    onGetCBCarBrand({
      idOrgCaso: state.idOrgCaso
    })
    onGetCBCarType({
      concepto: '16'
    })
    onGetCBCompany()
    onGetCBComune({
      rutCia: 8600399880,
      parametro: 45
    })
    onGetCBSure({
      concepto: '212'
    })
    onGetCBCountry({
      concepto: '18'
    })
  }, [])

  useEffect(() => {
    if (data.response) {
      toast(data.response)
      data.response = null
    }
  }, [data.response])

  useEffect(() => {
    setComunaConductor(
      data?.cbComune.find((element) =>
        element?.id.includes(data?.implicatedDetail[0]?.IdComunaConductor)
      )?.atr4
    )
    setComunaImplicado(
      data?.cbComune.find((element) =>
        element?.id.includes(data?.implicatedDetail[0]?.IdComunaImplicado)
      )?.atr4
    )
    setComunaPropietario(
      data?.cbComune.find((element) =>
        element?.id.includes(data?.implicatedDetail[0]?.IdComunaPropietario)
      )?.atr4
    )
  }, [data?.cbComune.length > 0])

  const onSubmit = (values) => {
    setShow(true)
    values.implicado.dvRut = values.implicado.rut.substr(-1)
    values.implicado.rut = values.implicado.rut
      .split('.')
      .join('')
      .split('-')
      .join('')
    values.propietario.dvRut = values.propietario.rut.substr(-1)
    values.propietario.rut = values.propietario.rut
      .split('.')
      .join('')
      .split('-')
      .join('')
    values.conductorIM.dvRut = values.conductorIM.rut.substr(-1)
    values.conductorIM.rut = values.conductorIM.rut
      .split('.')
      .join('')
      .split('-')
      .join('')
    setFormValues(values)
  }

  const onBack = () => {
    history(-1)
  }

  const onBitacora = () => {
    history('/bitacora', {
      state: {
        idCaso: state.idCaso,
        idImplicadoCaso: state.idImplicado,
        idOrganizacion: state.idOrgCaso
      }
    })
  }

  const onSubmitModal = async () => {
    setShow(false)
    await setLoading(true)
    try {
      await onPostImplicado(formValues)
    } catch (error) {
      toast.error(error)
    } finally {
      await setLoading(false)
      onBack()
    }
  }

  const initialValues = {
    terceroImplicado: {
      idCaso: state.idCaso,
      idImplicado: state.row.IdImplicado,
      seguro: state.row.IdSeguroImplicado,
      idCompania: state.row.IdCiaImplicado,
      idSiniestroIM: data?.implicatedDetail[0]?.SiniestroIM,
      fechaSiniestroIM:
        data?.implicatedDetail[0]?.FechaSiniestroIM &&
        data?.implicatedDetail[0]?.FechaSiniestroIM !== '0000-00-00'
          ? moment(data?.implicatedDetail[0]?.FechaSiniestroIM).format(
              'yyyy-MM-DD'
            )
          : null,
      tipoVehiculo: state.row.IdTipoVehiculo,
      patente: state.row.PlacaPatente,
      marcaVehiculo: data?.implicatedDetail[0]?.IdMarca,
      detalleDescripcion: data?.implicatedDetail[0]?.Descripcion
        ? data?.implicatedDetail[0]?.Descripcion
        : ''
    },
    implicado: {
      idInvolucrado: data?.implicatedDetail[0]?.IdInvolucradoImp
        ? data?.implicatedDetail[0]?.IdInvolucradoImp
        : 1,
      rut: prettifyRut(data?.implicatedDetail[0]?.RutImplicado),
      nombre: data?.implicatedDetail[0]?.NombreImplicado,
      direccion: data?.implicatedDetail[0]?.DireccionImplicado,
      email: data?.implicatedDetail[0]?.EmailImplicado,
      paisFono: data?.implicatedDetail[0]?.paisFonoImpl,
      fono: data?.implicatedDetail[0]?.FonoImplicado,
      paisMovil: data?.implicatedDetail[0]?.paisMovilImpl,
      movil: data?.implicatedDetail[0]?.MovilImplicado,
      comuna: data?.implicatedDetail[0]?.IdComunaImplicado,
      dvRut: ''
    },
    propietario: {
      idInvolucrado: data?.implicatedDetail[0]?.IdInvolucradoProp
        ? data?.implicatedDetail[0]?.IdInvolucradoProp
        : 2,
      rut: prettifyRut(data?.implicatedDetail[0]?.RutPropietario),
      nombre: data?.implicatedDetail[0]?.NombrePropietario
        ? data?.implicatedDetail[0]?.NombrePropietario
        : '',
      direccion: data?.implicatedDetail[0]?.DireccionPropietario,
      email: data?.implicatedDetail[0]?.EmailPropietario,
      paisFono: data?.implicatedDetail[0]?.paisFonoPropietario,
      fono: data?.implicatedDetail[0]?.FonoPropietario,
      paisMovil: data?.implicatedDetail[0]?.paisFonoPropietario,
      movil: data?.implicatedDetail[0]?.MovilPropietario,
      comuna: data?.implicatedDetail[0]?.IdComunaPropietario,
      dvRut: ''
    },
    conductorIM: {
      idInvolucrado: data?.implicatedDetail[0]?.IdInvolucradoCond
        ? data?.implicatedDetail[0]?.IdInvolucradoCond
        : 3,
      rut: prettifyRut(data?.implicatedDetail[0]?.RutConductor),
      nombre: data?.implicatedDetail[0]?.NombreConductor,
      direccion: data?.implicatedDetail[0]?.DireccionConductor,
      email: data?.implicatedDetail[0]?.EmailConductor,
      paisFono: data?.implicatedDetail[0]?.paisFonoConductor,
      fono: data?.implicatedDetail[0]?.FonoConductor,
      paisMovil: data?.implicatedDetail[0]?.paisMovilConductor,
      movil: data?.implicatedDetail[0]?.MovilConductor,
      comuna: data?.implicatedDetail[0]?.IdComunaConductor,
      dvRut: ''
    }
  }

  const optionsForms = {
    initialValues,
    form: state.form,
    row: state.row,
    data
  }
  const optionsFormsInvolved = {
    initialValues,
    form: state.form,
    data,
    comunaImplicado,
    setComunaImplicado
  }

  const optionsFormsDrive = {
    initialValues,
    form: state.form,
    data,
    comunaConductor,
    setComunaConductor
  }

  const optionsFormsProperty = {
    initialValues,
    form: state.form,
    data,
    comunaPropietario,
    setComunaPropietario
  }

  return (
    <Container>
      <LoadingComponent show={loading || data.loading} />
      {data &&
      data?.implicatedDetail[0] &&
      Object.keys(data?.implicatedDetail[0]).length > 0 ? (
        <Card className='square border border-4 z-index-1 m-4'>
          <Card.Body>
            <Formik
              className='m-2'
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema(
                new Date(state.fechaSiniestro)
              )}
            >
              <Form>
                <FormThirdInvolved {...optionsForms} />
                <Row>
                  <FormInvolved {...optionsFormsInvolved} />
                  <FormDrive {...optionsFormsDrive} />
                  <FormProperty {...optionsFormsProperty} />
                </Row>

                <Card.Body
                  style={{
                    float: 'right'
                  }}
                >
                  <Button
                    type='button'
                    variant='btn btn-secondary m-1  btn-xl '
                    onClick={() => onBack()}
                  >
                    Volver
                  </Button>

                  <Button
                    type='button'
                    onClick={() => onBitacora()}
                    variant='btn btn-info m-1  btn-xl'
                  >
                    Bitacora
                  </Button>

                  <Button type='submit' variant='btn btn-danger m-1 btn-xl'>
                    {state.form?.formLabel['gestcasos-editimpl-btn-actualizar']}
                  </Button>
                </Card.Body>

                {show && (
                  <Mensage
                    show={show}
                    handleClose={handleClose}
                    message='Esta Seguro que desea Actualizar este Caso Implicado'
                    onSubmitModal={() => onSubmitModal()}
                  />
                )}
              </Form>
            </Formik>
          </Card.Body>
        </Card>
      ) : null}
    </Container>
  )
}

const mapStateToProps = (state) => ({
  data: state.cases
})

const mapDispatchToProps = (dispatch) => ({
  onGetGestionCasesImplicatedDetail: (query) =>
    dispatch(getCasesImplicatedDetail(query)),
  onGetCBCarBrand: (query) => dispatch(getCBCasesCarBrand(query)),
  onGetCBSure: (query) => dispatch(getCBCasesSure(query)),
  onGetCBCountry: (query) => dispatch(getCBCountry(query)),
  onGetCBCarType: (query) => dispatch(getCBCasesCarType(query)),
  onGetCBComune: (query) => dispatch(getCBCasesCommune(query)),
  onGetCBCompany: () => dispatch(getCBCasesCompany()),
  onPostImplicado: (body) => dispatch(postCasesImplicado(body)),
  onCleanState: () => dispatch(cleanStateCase())
})

export default connect(mapStateToProps, mapDispatchToProps)(FormImplicatedCases)
